export class ReportDefinition {
    HasReportDefinition: number;
    HasReportParameterDefined: number;
    HasParameterValueDefined: number;
    IsSysGen: number;
    School_Domain: number;
    AllowUserSaveReport: boolean;
    AllowUserHideReport: boolean;
    IsSystem: boolean;
    AllowUserSaveParameter: boolean;
    AllowUserHideParameter: boolean;
    HiddenByDefault: boolean;
    AlwaysHidden: boolean;
    ReportParameter_ID: number;
    ParameterName_ID: number;
    ParameterName: String;
    ParameterValue_ID: number;
    Login_ID: number;
    // Value: String;
    Value: any;
    IsHidden: boolean;
    CanSave: boolean;
    RC_ID: number;
    Control: String;
    DataType: String;
    ShowAll: boolean;
    ShowOptionsVertically: boolean;
    IsDistrictDefinedParameter: boolean;
    IsUserDefinedParameter: boolean;
    SaveChecked: boolean;
    HideChecked: boolean;
    BackgroundColorForSavedDefinition: string;
    ParameterLabel: string;
   }
